import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PillCloseAddon = /*#__PURE__*/styled.div.withConfig({
  componentId: "kbngzd-0"
})(["cursor:pointer;height:", ";& > span{height:auto;}"], function (props) {
  return props.theme.space.xs;
});

var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/React.createElement(components.MultiValueRemove, props, /*#__PURE__*/React.createElement(PillCloseAddon, null, /*#__PURE__*/React.createElement(CloseXsmall, null)));
};

MultiValueRemove.style = function (base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    paddingLeft: 0,
    height: '100%',
    ':hover': {
      backgroundColor: '#EBF6FF'
    }
  });
};

export { MultiValueRemove };
//# sourceMappingURL=MultiValueRemove.js.map
